/**
 * Pequemimo cart drawer.
 * Enhances the cart into a slide-out panel using the Cart AJAX API and the
 * Section Rendering API. Progressive enhancement: if any request fails, we let
 * the native form/link behaviour take over (which targets the /cart page).
 */
(function () {
  var SECTION = 'cart-drawer';

  function drawer() {
    return document.getElementById('cart-drawer');
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function updateBubbles(count) {
    count = parseInt(count, 10) || 0;
    document.querySelectorAll('[data-cart-bubble]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function refreshDrawer(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('cart-drawer');
    var current = drawer();
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      current.dataset.cartCount = fresh.dataset.cartCount;
      updateBubbles(fresh.dataset.cartCount);
    }
  }

  function addToCart(form) {
    var data = new FormData(form);
    data.append('sections', SECTION);
    data.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (json) {
        if (json.sections) refreshDrawer(json.sections[SECTION]);
        openDrawer();
      })
      .catch(function () {
        form.submit();
      });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        sections: SECTION,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change failed');
        return res.json();
      })
      .then(function (json) {
        if (json.sections) refreshDrawer(json.sections[SECTION]);
      })
      .catch(function () {
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var qty = e.target.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      changeLine(qty.dataset.line, qty.dataset.to);
      return;
    }
    var remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.line, 0);
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form[action$="/cart/add"], form[action*="/cart/add?"]')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
